import {storeObservable} from "../../util/sessionstore";
import {global} from "../../appContext";
import {ITableColumn} from "../../index";
import {ObjectTypeId} from "../../constants";

export namespace nsObjectData {

    export class ObjectTableDefinition {

        constructor(private objectTypeId: ObjectTypeId, private isManual = false) {
        }

        public getTableDefinition(): ITableColumn[] {
            const keys: string[] = this.getTableKeys();

            return keys.map((k: string) => {
                const ret: ITableColumn = {
                    label: k,
                    key: k,
                    sort: false,
                };
                switch (k) {
                    case 'selector':
                        ret.label = '';
                        return ret;
                    case 'id':
                        ret.label = 'Id';
                        return ret;
                    case 'func':
                        ret.label = 'Funksjon';
                        return ret;
                    case 'EntryType':
                        ret.sort = false;
                        return ret;
                    default:
                        ret.sort = true;
                        return ret;
                }
            });
        }

        protected getTableKeys(): string[] {
            let keys: string[] = ['selector'];
            keys = keys
                .concat(storeObservable(`search.object.syncfields${this.objectTypeId}`)())
                .filter(key => this.showTableColumn(key));
            return keys;
        }

        showTableColumn(key: string): boolean {
            switch (key) {
                case "id":
                    return global.permissionValidator.superAdmin();
                default:
                    return true;
            }
        }

    }

}